import { LANDING_SLUGS } from '@modules/solicitacoes/constants/landingSlugs'

// Abre a landing estática do serviço em nova aba. Devolve false quando não há
// landing para o tipo (ex.: serviço cadastrado depois do último build) — aí o
// chamador mantém o fluxo antigo em vez de deixar o clique morrer.
export function abrirLandingServico({ idTipo } = {}) {
  // String(): as chaves do mapa são uuid; o chamador nem sempre garante o tipo
  // (view-jornada faz String(idTipo) logo abaixo, no fallback de rota).
  const chave = String(idTipo)
  // hasOwnProperty: o mapa é objeto literal e herda Object.prototype, então
  // idTipo='toString' devolveria uma função truthy e escaparia do guard abaixo.
  if (!Object.hasOwn(LANDING_SLUGS, chave)) return false

  const slug = LANDING_SLUGS[chave]
  if (!slug) return false

  const url = `${process.env.BASE_URL}servicos/${slug}.html`
  window.open(url, '_blank', 'noopener,noreferrer')
  return true
}
